"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_system_1 = require("styled-system");
var Box_1 = require("./Box");
var StyledLink = (0, Box_1.createBasicComponent)(function (props) { return ({
    textDecoration: 'none',
    color: 'inherit',
    fontSize: 'inherit',
    fontWeight: 'inherit',
    letterSpacing: 'inherit',
    lineHeight: 'inherit',
    cursor: 'pointer',
    fontFamily: props.theme.fonts.Roboto,
}); }, (0, styled_system_1.variant)({
    scale: 'links'
}));
StyledLink.displayName = 'Link';
StyledLink.defaultProps = { as: 'a' };
function Link(props) {
    if (props.disabled) {
        return (react_1.default.createElement(StyledLink, __assign({ as: "button" }, props, { href: undefined })));
    }
    return (react_1.default.createElement(StyledLink, __assign({}, props)));
}
exports.default = Link;
